import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#000000] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1">
            <img
              src="https://sitamaniglobal.com/assets/images/smg-logo.png"
              alt="SMG Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="font-inter text-sm text-gray-400 leading-relaxed">
              Leading manufacturer of ISPM-15 certified wooden pallets and export packaging solutions in India.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-poppins font-semibold text-white mb-4 uppercase text-sm tracking-wide">Quick Links</h3>
            <ul className="space-y-2 font-inter text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/about-sita-mani-global" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/quality-compliance" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-quality">Quality & Compliance</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-poppins font-semibold text-white mb-4 uppercase text-sm tracking-wide">Products</h3>
            <ul className="space-y-2 font-inter text-sm">
              <li><Link to="/products/wooden-pallets" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-wooden-pallets">Wooden Pallets</Link></li>
              <li><Link to="/products/industrial-packaging" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-industrial-packaging">Industrial Packaging</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-[#B11217] transition-colors" data-testid="footer-link-industries">Industries Served</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-poppins font-semibold text-white mb-4 uppercase text-sm tracking-wide">Contact</h3>
            <ul className="space-y-3 font-inter text-sm">
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1 text-[#B11217]" />
                <div>
                  <div className="font-semibold text-white">Office:</div>
                  <span>Gandhidham, Kachchh<br />Gujarat, India</span>
                </div>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1 text-[#B11217]" />
                <div>
                  <div className="font-semibold text-white">Factory:</div>
                  <span>Varsamedi, near Matiyadev Temple,<br />Anjar Highway, Kachchh,<br />Gujarat - 370110, India</span>
                </div>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone size={18} className="flex-shrink-0 text-[#B11217]" />
                <span>+91 99883 51111</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail size={18} className="flex-shrink-0 text-[#B11217]" />
                <span>sales@sitamaniglobal.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="font-inter text-sm text-gray-400">
            © {new Date().getFullYear()} Sita Mani Global. All Rights Reserved. | Serving PAN India & Export Markets
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;